import React from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const StepDireccionForm = ({
  modoEdicion,
  nuevaDireccion,
  setNuevaDireccion,
  nuevoTipoDireccion,
  setNuevoTipoDireccion,
  comuna,
  setComuna,
  region,
  setRegion,
  regiones,
  comunas,
  nuevoDirecciones,
  indiceEdicionDireccion,
  handleGuardarDireccion,
  handleEliminarDireccion,
  handleDesactivarDomicilio,
  handleSeleccionarDireccion,
  onPrev,
  onNext,
}) => {
  return (
    <div className="card">
      <div className="p-d-flex p-jc-between p-ai-center mb-3">
        <div>
          <h6>Ingrese las direcciones a registrar</h6>
        </div>
      </div>

      <div className="p-fluid formgrid grid">
        {/* Tipo dirección */}
        <div className="field col-12 md:col-2">
          <label>Tipo</label>
          <Dropdown
            id="tipodireccion"
            value={nuevoTipoDireccion}
            onChange={(e) => setNuevoTipoDireccion(e.value)}
            options={[
              { name: "COMERCIAL", value: "COMERCIAL" },
              { name: "NATURAL", value: "NATURAL" },
              { name: "OTRO", value: "OTRO" },
            ]}
            optionLabel="name"
            placeholder="Seleccione una opción"
            className="p-inputtext-sm"
            style={{ borderRadius: "4px" }}
          />
        </div>

        {/* Dirección */}
        <div className="field col-12 md:col-2">
          <label> Dirección </label>
          <InputText
            id="direccion"
            type="text"
            value={nuevaDireccion}
            onChange={(e) => setNuevaDireccion(e.target.value.toUpperCase())}
            className="p-inputtext-sm"
            style={{ borderRadius: "4px" }}
            placeholder="Ingrese dirección"
            maxLength={45}
          />
        </div>

        {/* Región */}
        <div className="field col-12 md:col-3">
          <label>Región</label>
          <Dropdown
            id="region"
            value={region}
            onChange={(e) => {
              setRegion(e.value);
              setComuna("");
            }}
            options={regiones}
            placeholder="Seleccione una región"
            className="p-inputtext-sm"
            style={{ borderRadius: "4px" }}
          />
        </div>

        {/* Comuna */}
        <div className="field col-12 md:col-3">
          <label>Comuna</label>
          <Dropdown
            id="comuna"
            value={comuna}
            onChange={(e) => setComuna(e.value)}
            options={comunas}
            placeholder="Seleccione una comuna"
            className="p-inputtext-sm"
            style={{ borderRadius: "4px" }}
            disabled={!region}
          />
        </div>

        {/* Botón agregar/guardar */}
        <div className="field col-12 md:col-2 mt-4">
          <Button
            label={indiceEdicionDireccion !== null ? "Guardar" : "Agregar"}
            icon={indiceEdicionDireccion !== null ? "pi pi-save" : "pi pi-plus"}
            className="p-button-rounded p-button-outlined p-button-success"
            onClick={handleGuardarDireccion}
          />
        </div>

        {/* Tabla de direcciones */}
        <Card className="mt-2" style={{ width: "100%" }}>
          {nuevoDirecciones.length > 0 ? (
            <DataTable
              value={nuevoDirecciones}
              scrollHeight="150px"
              className="p-datatable-sm"
              tableStyle={{ fontSize: "0.875rem" }}
            >
              <Column field="tipo" header="Tipo" />
              <Column field="direccion" header="Dirección" />
              <Column field="region" header="Región" />
              <Column field="comuna" header="Comuna" />
              <Column
                header="Acciones"
                body={(rowData, options) => (
                  <div className="p-d-flex p-ai-center">
                    <Button
                      icon="pi pi-pencil"
                      size="small"
                      text
                      onClick={() => handleSeleccionarDireccion(options.rowIndex)}
                    />
                    {modoEdicion ? (
                      <Button
                        icon="pi pi-times"
                        size="small"
                        severity="danger"
                        text
                        onClick={() => handleDesactivarDomicilio(options.rowIndex)}
                      />
                    ) : (
                      <Button
                        icon="pi pi-times"
                        size="small"
                        severity="danger"
                        text
                        onClick={() => handleEliminarDireccion(options.rowIndex)}
                      />
                    )}
                  </div>
                )}
              />
            </DataTable>
          ) : (
            <p className="p-text-center">No se han agregado direcciones.</p>
          )}
        </Card>
      </div>

      <br />
      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={onPrev} />
        <Button label="" icon="pi pi-arrow-right" rounded outlined iconPos="right" onClick={onNext} />
      </div>
    </div>
  );
};

export default StepDireccionForm;
